import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-tooltip',
  templateUrl: './message-tooltip.component.html',
  styleUrls: ['./message-tooltip.component.scss']
})
export class MessageTooltipComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
